<template>
    <div class="modal-card" style="width:350px">
        <header class="modal-card-head">
            <p class="modal-card-title">Brukerdetaljer</p>
        </header>    

        <form @submit.prevent="commitChanges">    
            <section class="modal-card-body">

                <b-field v-if="isNewUser" label="Epost">
                    <b-input
                        type="email"
                        v-model="user.email"
                        placeholder="Epostadresse"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Fornavn">
                    <b-input
                        type="text"
                        v-model="user.firstname"
                        placeholder="Fornavn"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Etternavn">
                    <b-input
                        type="text"
                        v-model="user.lastname"
                        placeholder="Etternavn"
                        required>
                    </b-input>
                </b-field>

                <b-field label="Firma">
                    <b-select placeholder="Velg firma" v-model="user.companyId" required>
                        <option
                            v-for="option in customers"
                            :value="option.id"
                            :key="option.id">
                            {{ `${option.name} (${option.id})` }}
                        </option>
                    </b-select>
                </b-field>

                <div class="field">
                    <b-checkbox v-model="user.isAdministrator">
                        Administrator
                    </b-checkbox>
                </div>

                <div class="field" v-if="errorMsg">
                    {{ errorMsg }}
                </div>
                
            </section>

            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Avbryt</button>
                <button class="button is-primary" type="submit">Ok</button>
            </footer>
        </form>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    props: ['user', 'isNewUser'],
    data () {
        return {
            errorMsg: undefined
        }
    },
    methods: {
        ...mapActions('users', ['editUser']),
        ...mapActions('customers', ['getCustomers']),
        async commitChanges () {
            try {
                await this.editUser(this.user)
                this.$parent.close()
            } catch (error) {
                this.errorMsg = error.message
            }
        }
    },
    created () {
        this.getCustomers()
    },
    computed: mapGetters('customers', ['customers'])
}
</script>

